import { bankAccountService } from 'hq/services';
import { useMutation } from 'react-query';

export const useApprovePendingBankAccount = () => {
  const mutationFn = async (id: string) => await bankAccountService.approvePendingBankAccounts(id);

  return useMutation(mutationFn);
};
